import React from 'react';
import './App.css';
import {
  Route,
  HashRouter
} from "react-router-dom";
import ReservationVisite from './Pages/ReservationVisite';
import { Container } from 'semantic-ui-react';

const App: React.FC = () => {
  return (
    <HashRouter>
      <Container className="App">
        <div className="content">
            <Route path="/resa">
                <ReservationVisite />
            </Route>
        </div>
    </Container>
    </HashRouter>
  );
}

export default App;
